
import { api_get, api_post } from "./utils";

const IdentityAPI = {
    create: _createIdentity,
    update: _updateIdentity,
    updateRole: _updateRole,
    get: _getIdentity,
    getByKeyList: _getByKeyList,
    supportFetchIdentityForUser: _supportFetchIdentityForUser,
    list: _getList,
    listAll: _fetchListAll,
    sudoSetVerified: _sudoSetVerified,
    sudoSetDedicated: _sudoSetDedicated,
}


async function _createIdentity(name: string,
    email: string,
    color: string,
    role: string,
    verified: string,
    phone: string,
    addr1: string,
    addr2: string,
    city: string,
    state: string,
    zipcode: string
) {
    return api_post('/identity/create',
        {"name": name,
            "email": email,
            "color": color,
            "role": role,
            'verified': verified,
            'phone': phone,
            'addr1': addr1,
            'addr2': addr2,
            'city': city,
            'state': state,
            'zipcode': zipcode
        })
        .then(async (res) => {
            if (res.ok) {
                return await res.json();
            }
            else {
                throw "what"
            }
        });
}



async function _updateIdentity(identityKey: string,
    name: string,
    email: string,
    color: string,
    role: string,
    verified: string,
    dedicated: boolean,
    phone: string,
    addr1: string,
    addr2: string,
    city: string,
    state: string,
    zipcode: string
) {
    return api_post('/identity/update',
        {"name": name,
            "email": email,
            "identity": identityKey,
            "color": color,
            "role": role,
            'verified': verified,
            'dedicated': dedicated ? 'yes' : 'no',
            'phone': phone,
            'addr1': addr1,
            'addr2': addr2,
            'city': city,
            'state': state,
            'zipcode': zipcode
        })
        .then(async (res) => {
            if (res.ok) {
                return await res.json();
            }
            else {
                throw "what"
            }
        });
}

async function _updateRole(identityKey: string, role: string) {
    return api_post('/identity/sudo-update-role',
        {"role": role,
            "identity": identityKey,
        })
        .then(async (res) => {
            if (res.ok) {
                return await res.json();
            }
            else {
                throw "what"
            }
        });
}

async function _getIdentity(identity: string) {
    return api_get(`/identity/?identity=${identity}`)
        .then(async (res) => {
            if (res.ok) {
                return await res.json();
            }
        });
}

async function _getByKeyList(myIdentity: string, identity: string[]) {
    const identity_list = identity.join(',');
    const params = {
        identity_list: identity_list,
        identity: myIdentity
    };
    return api_get('/identity/list-by-keys', params)
        .then(async (res) => {
            if (res.ok) {
                return await res.json();
            }
        });
}


async function _getList(cursor: string) {
    let url = '/identity/list/';
    if (cursor) { url += '?cursor=' + cursor; }
    return api_get(url).then((res) => {
        if (!res.ok) {
            return null;
        }
        else {
            return res.json();
        }
    });
}

async function _fetchListAll(identity: string, cursor: string) {
    let url = '/identity/list/all?identity=' + identity;
    if (cursor) { url += '&cursor=' + cursor; }
    return api_get(url).then((res) => {
        if (!res.ok) {
            return null;
        }
        else {
            return res.json();
        }
    });
}


async function _sudoSetVerified(identityKey: string, verified: string) {
    const url = '/identity/set-verified';
    return api_post(url, {identity: identityKey,
        verified: verified}).then((res) => {
        if (!res.ok) {
            return null;
        }
        else {
            return res.json();
        }
    });
}




async function _sudoSetDedicated(identityKey: string, dedicated: string) {
    const url = '/identity/set-dedicated';
    return api_post(url, {identity: identityKey,
        dedicated: dedicated}).then((res) => {
        if (!res.ok) {
            return null;
        }
        else {
            return res.json();
        }
    });
}


async function _supportFetchIdentityForUser(userKey: string) {
    const url = '/identity/support-identity-by-user?search_user=' + userKey;
    return api_get(url).then((res) => {
        if (!res.ok) {
            return null;
        }
        else {
            return res.json();
        }
    });

}

export default IdentityAPI;
